import React, { FunctionComponent } from "react";

import MapControl from "./map-control";
import useMap from "./use-map";
import AlpacaWatermark from "./alpaca-watermark";

const AlpacaAttributionControl: FunctionComponent<AlpacaAttributionProps> = ({
  position,
  mapRef,
}) => {
  const { map } = useMap();

  if (!map) {
    return null;
  }

  // Return
  return (
    <MapControl position={position} mapRef={mapRef} defaultStyles={false}>
      <a
        href="https://alpaca.travel"
        rel="nofollow noopener noreferrer"
        target="_blank"
        aria-label="Alpaca logo"
        className="alpaca-logo"
        style={{ left: -4, top: 4, position: "relative" }}
      >
        <AlpacaWatermark />
      </a>
    </MapControl>
  );
};

type AlpacaAttributionProps = {
  mapRef?: string;
  position?: "top-left" | "top-right" | "bottom-left" | "bottom-right";
  includeMapbox?: boolean;
};

export default React.memo(AlpacaAttributionControl);
